interface NumberFieldProps {
  label: string;
  value: number | '';
  onChange: (value: number | '') => void;
  required?: boolean;
  placeholder?: string;
  min?: number;
  max?: number;
  error?: string;
}

export default function NumberField({
  label,
  value,
  onChange,
  required = false,
  placeholder,
  min,
  max,
  error,
}: NumberFieldProps) {
  return (
    <div>
      <label className="block text-xs text-gray-400 mb-1.5">
        {label}
        {required && <span className="text-red-400 ml-1">*</span>}
      </label>
      <input
        type="number"
        value={value}
        onChange={(e) => {
          const val = e.target.value;
          onChange(val === '' ? '' : Number(val));
        }}
        placeholder={placeholder}
        min={min}
        max={max}
        className={`w-full bg-[#1a1f3a] border rounded-lg px-3 py-2 text-sm text-white placeholder-gray-500 focus:outline-none focus:border-orange-500/50 ${
          error ? 'border-red-500/50' : 'border-[#2d1b3d]'
        }`}
      />
      {error && <div className="text-xs text-red-400 mt-1">{error}</div>}
    </div>
  );
}



